"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Divider;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function Divider(_ref) {
  var style = _ref.style,
    className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement("div", {
    role: "separator",
    style: style,
    className: (0, _classnames["default"])(className, 'rrui__divider')
  }, /*#__PURE__*/_react["default"].createElement("hr", {
    className: "rrui__divider__line"
  }));
}

// Workaround for `react-hot-loader`.
// https://github.com/gaearon/react-hot-loader#checking-element-types
Divider.displayName = 'Divider';
//# sourceMappingURL=Divider.js.map